import templateUrl from './contact-list.html';

export default {
  templateUrl,
  bindings: {
    adverseEvent: '<',
    locked: '<'
  },
  controller: class ContactListComponent {
    constructor() {
      'ngInject';
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/adverse-event/contact-list/contact-list.component.js